import Types from "./Types";

const INITIAL_STATE = {
  users: [],
  subjects: [],
  activeSubscriptions: [],
  isLoading: false,
  subjectsLoading: false,
  activeSubscriptionsLoading: false,
  createLoading: false,
  count: 0,
  lastPage: 1,
};

export default function asqueraPractice(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_PRACTICE_USERS_SUCCESS: {
      return {
        ...state,
        users: Array.isArray(payload.data) ? payload.data : [],
        count: payload.count || 0,
        lastPage: payload.lastPage || 1,
        isLoading: false,
      };
    }
    case Types.GET_PRACTICE_USERS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case Types.PRACTICE_USERS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }
    case Types.GET_PRACTICE_SUBJECTS_SUCCESS: {
      return {
        ...state,
        subjects: Array.isArray(payload) ? payload : [],
        subjectsLoading: false,
      };
    }
    case Types.GET_PRACTICE_SUBJECTS_FAIL: {
      return {
        ...state,
        subjectsLoading: false,
      };
    }
    case Types.PRACTICE_SUBJECTS_LOADING: {
      return {
        ...state,
        subjectsLoading: payload,
      };
    }
    case Types.GET_ACTIVE_SUBSCRIPTIONS_SUCCESS: {
      return {
        ...state,
        activeSubscriptions: Array.isArray(payload) ? payload : [],
        activeSubscriptionsLoading: false,
      };
    }
    case Types.GET_ACTIVE_SUBSCRIPTIONS_FAIL: {
      return {
        ...state,
        activeSubscriptionsLoading: false,
      };
    }
    case Types.ACTIVE_SUBSCRIPTIONS_LOADING: {
      return {
        ...state,
        activeSubscriptionsLoading: payload,
      };
    }
    case Types.CREATE_SUBSCRIPTION_LOADING: {
      return {
        ...state,
        createLoading: payload,
      };
    }
    case Types.CREATE_PRACTICE_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        createLoading: false,
      };
    }
    case Types.CREATE_PRACTICE_SUBSCRIPTION_FAIL: {
      return {
        ...state,
        createLoading: false,
      };
    }
    default: {
      return state;
    }
  }
}
